import { useJsApiLoader } from '@react-google-maps/api'
import { Library } from '@googlemaps/js-api-loader'

const libraries: Library[] = ['places', 'marker' ]
const language = 'ru'
const region = 'RU'

export const useInitGMap = () => {
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY
      ? process.env.REACT_APP_GOOGLE_MAPS_API_KEY
      : '',
    libraries: libraries,
    region: region,
    language: language,
  })

  return { isLoaded }
}
